class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.header = document.querySelector(".header");
    this.closeButton = this.querySelector(".mega-menu__close");
    this.headerHeight = this.header.offsetHeight;
    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.links_open.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        e.preventDefault();
        let event = e;
        // Check if mouse stay 1 second on hover on link
        setTimeout(
          function (e) {
            if (link.matches(":hover")) {
              this.toggleMenu(link);
            }
          }.bind(this),
          350
        );
      });
    });

    this.links_open.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });

    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.simpleLinks.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        this.querySelectorAll(".link").forEach((link) => {
          link.classList.remove("active");
        });

        this.querySelectorAll(".mega-menu__sub-container").forEach((panel) => {
          panel.classList.remove("active");
        });

        this.header.classList.remove("header--active");
      });
    });

    this.imageLinks = this.querySelectorAll(".menu-link-image");
    this.imageLinks.forEach((link) => {
      link.addEventListener("mouseover", this.displayImage.bind(this));
      link.addEventListener("mouseleave", this.hideImage.bind(this));
    });

    document
      .querySelector("#section-w-header")
      .addEventListener("mouseleave", () => {
        this.closeMenu();
      });

    if (window.innerWidth >= 990) {
      this.header.addEventListener("mouseenter", () => {
        this.header.classList.add("header--hover");
        document.querySelector("body").classList.add("shadow");
      });

      this.header.addEventListener("mouseleave", () => {
        this.header.classList.remove("header--hover");
        if (
          !document.querySelector(".header--active") &&
          !document.querySelector("side-cart").classList.contains("open")
        ) {
          document.querySelector("body").classList.remove("shadow");
        }
      });
    }

    // this.closeButton.addEventListener("click", () => this.closeMenu());

    this.updateHeaderPosition();
    window.addEventListener("scroll", () => {
      this.updateHeaderPosition();
    });
  }

  displayImage(e) {
    let link = e.currentTarget;
    let attribute = link.getAttribute("data-display-image");
    document.querySelectorAll(".hover-link-image").forEach((link) => {
      if (link.getAttribute("data-display-image") == attribute) {
        link.classList.add("active");
      }
    });
  }

  hideImage(e) {
    document.querySelectorAll(".hover-link-image").forEach((link) => {
      link.classList.remove("active");
    });
  }

  toggleMenu(link) {
    let currentLink = link.getAttribute("data-open-mega-menu");
    document.querySelectorAll(".mega-menu__sub-container.active").forEach((link) => {
      link.classList.remove("active");
    });
    document.querySelectorAll('[data-open-mega-menu]').forEach((item) => item.classList.remove('active'));
    link.classList.add('active');
    document
      .querySelectorAll(".mega-menu__sub-container")
      .forEach((sublink) => {
        if (currentLink == sublink.getAttribute("data-open-mega-menu-drawer")) {
          sublink.classList.add("active");
          swipers.forEach((swiper) => {
            swiper.scrollbar.updateSize();
          });
        }
      });
  }

  closeMenu() {
    this.querySelectorAll(".link").forEach((link) => {
      link.classList.remove("active");
    });

    document.querySelectorAll(".mega-menu__sub-container.active").forEach((link) => {
      link.classList.remove("active");
    });

    this.querySelectorAll(".mega-menu__sub-container").forEach((panel) => {
      panel.classList.remove("active");
    });

    this.header.classList.remove("header--active");
    document.querySelector("body").classList.remove("shadow");
  }

  updateHeaderPosition() {
    if (window.scrollY > 300 && window.innerWidth >= 990) {
      this.header.classList.add("header--scrolled");
      document.querySelector("body").style.paddingTop =
        this.headerHeight + "px";
      document.querySelector("body").classList.add("on-scroll");
      document
        .querySelector("#section-w-header")
        .classList.add("section-header-scrolled");
    } else {
      document.querySelector("body").style.paddingTop = 0;
      document.querySelector("body").classList.remove("on-scroll");
      this.header.classList.remove("header--scrolled");
      document
        .querySelector("#section-w-header")
        .classList.remove("section-header-scrolled");
    }
  }
}

customElements.define("mega-menu", MegaMenu);

class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelector(".open-drawer-menu");
    this.closeButton = this.querySelector(".drawer-menu__close");
    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.main_menu = this.querySelector(".drawer-menu__linklists");
    this.return_btn = this.querySelector(".drawer-menu__return");

    this.return_btn_collections = this.querySelectorAll("[data-drawer-return]");

    this.return_btn_collections.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.returnMenu(event)?.bind(this);
      });
    });


    this.initEventsHeight();
    document.addEventListener('resize', this.initEventsHeight.bind(this));

    this.openButton.addEventListener("click", () => this.openMenu());
    this.closeButton.addEventListener("click", () => this.closeMenu());

    this.links_open.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleMenu(link)?.bind(this);
      });
    });

    this.return_btn.addEventListener("click", (event) => {
      this.returnMenu(event)?.bind(this);
    });
  }

  initEventsHeight() {
    let searchHeight = this.querySelector('.drawer-menu__search').clientHeight;
    let headerHeight = this.querySelector('.drawer-menu__header').clientHeight;
    let footerHeight = this.querySelector('.header-top__linklist').clientHeight;

    let footerHeader = footerHeight + headerHeight + searchHeight;
    let footerHeaderMobile = footerHeight + searchHeight;
    document.documentElement.style.setProperty('--footer-header-height', `${footerHeader}px`);

    this.querySelector('.drawer-menu__linklists').style.minHeight = `calc(100 * var(--vh) - ${footerHeader}px - 4px)`;
    this.querySelector('.drawer-menu__main-content').style.minHeight = `calc(100 * var(--vh) - ${footerHeaderMobile}px )`;
    this.querySelectorAll('.mega-menu__panel').forEach((panel) => {
      panel.style.minHeight = `calc(100 * var(--vh) - ${footerHeader}px - 4px)`;
    }
    );

  }

  openMenu() {
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-drawer");
  }

  closeMenu() {
    this.classList.remove("open");
    document.querySelector("body").classList.remove("shadow-drawer");
  }

  toggleMenu(link) {
    let currentLink = link;
    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = this.querySelector(
      `.mega-menu__panel[data-mega-menu="${menu}"]`
    );

    let parentMenuHandle = link.closest('.mega-menu__panel--first')?.getAttribute('data-mega-menu');

    let parentMenu = currentLink.getAttribute("data-parent-menu");

    console.log(currentLink)
    
    if (parentMenuHandle) {
       menuElement = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${menu}"][data-parent-menu="${parentMenuHandle}"]`
      );      
    } 

    
    if (parentMenu) {
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
    }


    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--first.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelector(".mega-menu__panel--first.mega-menu__panel--actif")
        .classList.remove("mega-menu__panel--actif");
    }

    this.main_menu.classList.add("hidden");
    menuElement.classList.add("mega-menu__panel--actif");
    this.return_btn.classList.remove("hidden");

    let handle_slider = menuElement.dataset.megaMenu;

    console.log(handle_slider)
  }

  returnMenu(event) {
    event.preventDefault();

    let currentMenu = this.querySelector(".mega-menu__panel--actif");

    if (currentMenu.classList.contains("mega-menu__panel--second")) {
      currentMenu.classList.remove("mega-menu__panel--actif");
      let parentMenu = currentMenu.getAttribute("data-parent-menu");
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
      parentMenu.classList.add("mega-menu__panel--actif");
    } else {
      currentMenu.classList.remove("mega-menu__panel--actif");
      this.main_menu.classList.remove("hidden");
      this.return_btn.classList.add("hidden");
    }
  }
}

customElements.define("drawer-menu", DrawerMenu);
let swipers = [];
class Sliderv2 extends HTMLElement {
  constructor() {
    super();

    this.initSlider();
  }




  initSlider() {
    swipers.push(
      new Swiper(this.querySelector(".swiper"), {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        slidesPerView: "auto",

        spaceBetween: 20,

        // If we need pagination
        pagination: {
          el: this.querySelector(".swiper-pagination"),
        },

        // Navigation arrows
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },

        // And if we need scrollbar
        scrollbar: {
          el: this.querySelector(".swiper-scrollbar"),
        },
        on: {
          observerUpdate: () => {
            swiper.scrollbar.updateSize();
          },
        },

        breakpoints: {
          990: {
            spaceBetween: 24,
          },
        }
      })
    );
  }
}

customElements.define("menu-slider", Sliderv2);
